import { Alert, Box, Drawer } from '@mui/material';
import { UserForm } from 'components/@admin/@users/UserForm';
import CloseButton from 'components/@home/drawers/CloseButton';
import { Formik } from 'formik';
import { bool, func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import { useCreateUserMutation, useEditUserMutation } from 'store/app/entities/UsersSlice';

const getBody = async ({ isApp, isReadOnly, role, phone }) => ({
  isApp: isApp?.[0] === 'on' ? 1 : 0,
  isReadOnly: isReadOnly?.[0] === 'on' ? 1 : 0,
  role,
  phone,
});

const UserDrawer = ({ user, isOpen, onClose }) => {
  const isEdit = user?._id;
  const [createUser, createUserStatus] = useCreateUserMutation();
  const [editUser, editUserStatus] = useEditUserMutation();
  const { error, isLoading, isError } = {
    error: createUserStatus.error || editUserStatus.error,
    isLoading: createUserStatus.isLoading || editUserStatus.isLoading,
    isError: createUserStatus.isError || editUserStatus.isError,
  };
  const handleSubmit = async ({ _id, ...values }) => {
    const body = await getBody(values);
    const ret = _id ? await editUser({ _id, body }) : await createUser(body);
    if (!ret.error) {
      onClose();
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: { xs: '100%', sm: 480 },
            maxWidth: '100vw',
            boxSizing: 'border-box',
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', height: '100%', width: '100%', bgcolor: 'background.paper' }}>
        <Box sx={{ pt: 2.5, pl: 1.5, flex: '0 0 auto' }}>
          <CloseButton onClick={onClose} />
        </Box>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {isError && (
            <Box sx={{ px: 2.5, pt: 2 }}>
              <Alert severity="error">
                {error?.data?.message || error?.error || I18n.t('UserDrawer.Unexpected error')}
              </Alert>
            </Box>
          )}
          <Formik
            key={isEdit ? user._id : 'new'}
            enableReinitialize
            initialValues={{
              ...user,
              isApp: user?.isApp ? ['on'] : [],
              isReadOnly: user?.isReadOnly ? ['on'] : [],
            }}
            onSubmit={handleSubmit}
          >
            <UserForm
              user={user}
              onClose={onClose}
              isLoading={isLoading}
              title={isEdit ? I18n.t('UserDrawer.Edit') : I18n.t('UserDrawer.Create user')}
            />
          </Formik>
        </Box>
      </Box>
    </Drawer>
  );
};

UserDrawer.propTypes = {
  user: object,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default UserDrawer;
